import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { uiStore } from 'store';
import { Localisations } from 'components/localisations';
import { GlobalStyles } from '@styles';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'App';
import { observer } from 'mobx-react-lite';
import { SideMenu } from 'components/sideMenu';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const Application = observer(() => (
	<>
		<BrowserRouter>
			<ThemeProvider theme={uiStore.theme}>
				<GlobalStyles />
				<Localisations>
					<SideMenu />
					<App />
				</Localisations>
			</ThemeProvider>
		</BrowserRouter>
	</>
));

root.render(<Application />);
